module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_5010.4683bc57.png";